import { useState } from 'react'
import { useQuery, useQueryClient } from 'react-query'
import { authService } from '../services/api'

function formatWhen(value: string): string {
  return new Date(value).toLocaleString('fr-FR', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

/**
 * * Profile control for the personal API token. The secret is shown once.
 */
export function PersonalAccessTokenCard() {
  const queryClient = useQueryClient()
  const [plaintext, setPlaintext] = useState<string | null>(null)
  const [notice, setNotice] = useState('')
  const [busy, setBusy] = useState(false)
  const status = useQuery('personal-token', authService.personalTokenStatus)

  const generate = async () => {
    setBusy(true)
    setNotice('')
    try {
      const issued = await authService.createPersonalToken()
      setPlaintext(issued.token)
      await queryClient.invalidateQueries('personal-token')
    } catch {
      setNotice('Le jeton n\'a pas pu être généré.')
    } finally {
      setBusy(false)
    }
  }

  const revoke = async () => {
    setBusy(true)
    setNotice('')
    try {
      await authService.revokePersonalToken()
      setPlaintext(null)
      await queryClient.invalidateQueries('personal-token')
    } catch {
      setNotice('Le jeton n\'a pas pu être révoqué.')
    } finally {
      setBusy(false)
    }
  }

  const createdAt = status.data?.createdAt

  return (
    <div className="card mt-6">
      <div className="px-6 py-4 space-y-3">
        <h2 className="text-lg font-medium text-primary">Jeton personnel</h2>
        <p className="text-sm text-secondary">
          Ce jeton appelle l'API à votre place pour déployer un agent ou affecter une instance. Il ne s'affiche qu'une fois. Un nouvel envoi remplace le précédent.
        </p>
        {status.data?.active && createdAt ? (
          <p className="text-sm text-primary">Un jeton est actif depuis le {formatWhen(createdAt)}.</p>
        ) : (
          <p className="text-sm text-primary">Aucun jeton actif.</p>
        )}
        {plaintext ? (
          <label className="block text-sm text-secondary" htmlFor="personal-token">
            Copiez-le maintenant
            <input id="personal-token" name="personal-token" className="form-input mt-1" readOnly value={plaintext} />
          </label>
        ) : null}
        {notice ? <p className="text-sm text-error">{notice}</p> : null}
        <div className="flex flex-wrap gap-2">
          <button type="button" className="button button--primary" onClick={() => void generate()} disabled={busy}>
            Générer un jeton
          </button>
          {status.data?.active ? (
            <button type="button" className="button button--secondary" onClick={() => void revoke()} disabled={busy}>
              Révoquer
            </button>
          ) : null}
        </div>
      </div>
    </div>
  )
}
